import { TagBadge } from "../../Overview/CalendarView/TagBadge";

export const RestTravelBadge = ({ dateString, size = 22, popOutView = false }) => (
  <TagBadge dateString={dateString} size={size} popOutView={popOutView} />
);
